import { render, staticRenderFns } from "./RecuentoFolios.vue?vue&type=template&id=483d499a"
import script from "./RecuentoFolios.vue?vue&type=script&lang=js"
export * from "./RecuentoFolios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports